import { DigestOccurrence } from '../../generated'
import {
  daysBeforeLabel,
  formatHour,
  sendAtTimeToHour,
} from './digestSendTime.ts'

export type DigestOccurrenceTone = 'success' | 'info' | 'neutral' | 'warning'

export interface DigestOccurrenceStatus {
  label: string
  tone: DigestOccurrenceTone
  reason?: string
}

export function digestOccurrenceStatus(
  occurrence: DigestOccurrence
): DigestOccurrenceStatus {
  if (occurrence.sent) {
    return { label: 'Sent', tone: 'info' }
  }
  if (!occurrence.isRegularEvent) {
    return { label: "Won't send", tone: 'neutral', reason: 'Not a regular event' }
  }
  if (occurrence.digestId == null) {
    return { label: 'No digest', tone: 'neutral', reason: 'The digest is not set up' }
  }
  if (!occurrence.digestEnabled) {
    return { label: "Won't send", tone: 'neutral', reason: 'The digest is off' }
  }
  if (occurrence.skippedByRule) {
    return { label: 'Skipped', tone: 'warning', reason: 'Skip rule' }
  }
  if (occurrence.sendTimePassed) {
    return { label: 'Not sent', tone: 'warning', reason: 'The send time has passed' }
  }
  return { label: 'Will send', tone: 'success', reason: sendTime(occurrence) }
}

function sendTime(occurrence: DigestOccurrence): string | undefined {
  const { daysBefore, sendAtTime } = occurrence
  if (daysBefore == null || sendAtTime == null) return undefined
  return `${daysBeforeLabel(daysBefore)}, at ${formatHour(sendAtTimeToHour(sendAtTime))}`
}
